function removeRfqCartText() {
  document.querySelectorAll('.rfq-btn').forEach(function (button) {
    button.childNodes.forEach(function (node) {
      if (
        node.nodeType === Node.TEXT_NODE &&
        node.textContent.trim() === 'In den Warenkorb legen'
      ) {
        node.remove();
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', removeRfqCartText);

const observer = new MutationObserver(function () {
  removeRfqCartText();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});